module.exports = __webpack_public_path__ + "assets/img/topicon (1).671fd857.svg";